"use client";

import NavigationProgress from "@/app/_utils/components/NavigationProgress";

/**
 * Adds a loading progress bar to the top of the page.
 *
 * @returns The loading progress bar alongside children.
 */
export default function LoadingProgressBar({
  children,
}: {
  "children": React.ReactNode;
}): React.ReactElement {
  return (
    <>
      <NavigationProgress />
      {children}
    </>
  );
}
